import { put, takeLeading, takeEvery, takeLatest } from 'redux-saga/effects';

import chatApi from 'api/chat';
import { apiErrorHandler } from 'utils';

import {
  GET_LIST_CHAT_ROOM,
  GET_UNREAD_CHAT_ROOMS_COUNT,
  GET_CHAT_ROOM_DETAIL,
  GET_CHAT_ROOM_MESSAGES,
  SEND_CHAT_MESSAGE,
  READ_CHAT_ROOM,
} from './actionTypes';
import {
  actionGetUnreadChatRoomsCount,
  actionGetListChatRoomSuccess,
  actionGetListChatRoomFailed,
  actionGetUnreadChatRoomsCountSuccess,
  actionGetUnreadChatRoomsCountFailed,
  actionGetChatRoomDetailSuccess,
  actionGetChatRoomDetailFailed,
  actionGetChatRoomMessagesSuccess,
  actionGetChatRoomMessagesFailed,
  actionSendChatMessageSuccess,
  actionSendChatMessageFailed,
  actionSendChatMessageCompleted,
  actionReadChatRoomSuccess,
  actionReadChatRoomFailed,
} from './actions';

function* getListChatRoom({ payload }) {
  try {
    const { isLoadMore, ...params } = payload;

    const response = yield chatApi.getListChatRoom(params);

    yield put(
      actionGetListChatRoomSuccess({ ...response.payload, isLoadMore }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetListChatRoomFailed());
  }
}

function* getUnreadChatRoomsCount({ payload }) {
  try {
    const { place } = payload;
    const response = yield chatApi.getListChatRoom({
      place,
      unread: true,
      page: 1,
      limit: 1,
    });

    yield put(actionGetUnreadChatRoomsCountSuccess({
      count: response.payload?.total || 0,
      place,
    }));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetUnreadChatRoomsCountFailed());
  }
}

function* getChatRoomDetail({ payload }) {
  try {
    const response = yield chatApi.getChatRoomDetail(payload);

    yield put(
      actionGetChatRoomDetailSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetChatRoomDetailFailed());
  }
}

function* getChatRoomMessages({ payload }) {
  try {
    const { isLoadMore, ...params } = payload;

    const response = yield chatApi.getChatRoomMessages(params);

    yield put(
      actionGetChatRoomMessagesSuccess({ ...response.payload, isLoadMore }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetChatRoomMessagesFailed());
  }
}

function* sendChatMessage({ payload }) {
  try {
    const { id, place, text, textClientId, files = [] } = payload;

    if (text) {
      const response = yield chatApi.sendMessage({ id, place, text });
      yield put(actionSendChatMessageSuccess({
        message: response.payload,
        clientId: textClientId,
      }));
    }

    for (let i = 0; i < files.length; i += 1) {
      const item = files[i];

      const uploadResponse = yield chatApi.uploadChatFile(item.file);
      const fileUrl = uploadResponse.payload;

      const body = item.isImage
        ? { id, place, image: fileUrl }
        : {
          id,
          place,
          text: JSON.stringify({
            name: item.name,
            size: item.size,
            type: item.type,
            url: fileUrl,
          }),
        };

      const response = yield chatApi.sendMessage(body);
      yield put(actionSendChatMessageSuccess({
        message: response.payload,
        clientId: item.clientId,
      }));
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionSendChatMessageFailed());
  } finally {
    yield put(actionSendChatMessageCompleted());
  }
}

function* readChatRoom({ payload }) {
  try {
    yield chatApi.readMessage(payload);

    yield put(actionReadChatRoomSuccess({ id: payload.id }));
    yield put(actionGetUnreadChatRoomsCount({ place: payload.place }));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionReadChatRoomFailed());
  }
}

export default function* chatSaga() {
  yield takeLeading(GET_LIST_CHAT_ROOM, getListChatRoom);
  yield takeLatest(GET_UNREAD_CHAT_ROOMS_COUNT, getUnreadChatRoomsCount);
  yield takeLeading(GET_CHAT_ROOM_DETAIL, getChatRoomDetail);
  yield takeLeading(GET_CHAT_ROOM_MESSAGES, getChatRoomMessages);
  yield takeEvery(SEND_CHAT_MESSAGE, sendChatMessage);
  yield takeLeading(READ_CHAT_ROOM, readChatRoom);
}
